import { defineMessages } from 'react-intl'

/** Flight itinerary, bundle, and transfer copy — `docs/product-taxonomy.md` §9. */
const flightBundleGlossaryMessages = defineMessages({
  oneWayFlight: {
    defaultMessage: 'One-way flight',
    id: 'SRdjvZOxX7rf_vK2McBw',
    description: 'Label for a one-way flight itinerary in trip planner, cart, and offer summaries',
  },
  returnFlight: {
    defaultMessage: 'Return flight',
    id: 'vqnSw062cxM9wg1Mjg-S',
    description: 'Label for a single return leg or return-flight line item in order and offer views',
  },
  returnFlights: {
    defaultMessage: 'Return flights',
    id: 'jN6XHw1Lh70z-2x-Z2Zu',
    description: 'Label for return round-trip flight products on tiles, trip planner, and review rows',
  },
  multiCityFlights: {
    defaultMessage: 'Multi-city flights',
    id: 'N3Z9FNA7W5fYmUHAE1p0',
    description: 'Label for open-jaw or multi-segment flight itineraries in search and order summaries',
  },
  hotelPlusFlights: {
    defaultMessage: 'Hotel + flights',
    id: 'a4BjYJlsyVFO5AJazG9p',
    description: 'Merchandising label for bundled hotel and flight package pricing on offers and calendar',
  },
  hotelAndFlightBundle: {
    defaultMessage: 'Hotel & Flight bundle',
    id: 'on4XJ5cWSnaVM4s44ARw',
    description: 'Product title for combined hotel and flight package merchandising in search and cart',
  },
  nightsAndFlights: {
    defaultMessage: '{nights, plural, one {# night} other {# nights}} & flights',
    id: 'w39lt_oE4_A4m6LnUWef',
    description: 'Calendar or tile template combining night count with bundled flight availability',
  },
  nightsPlusFlightsFrom: {
    defaultMessage: '{nights, plural, one {# night} other {# nights}} + flights from',
    id: 'nEKSV2XrcU3nmYSEZ6l2',
    description: 'Price line for per-night stay plus add-on flight pricing from a given amount',
  },
  freeRoundTripTransfers: {
    defaultMessage: 'Free round-trip transfers',
    id: 'U-MIrKy8aaqAwDEBL3uy',
    description: 'Inclusion bullet for complimentary return airport or hotel transfer on the offer',
  },
  roundTripTransfers: {
    defaultMessage: 'Round-trip transfers',
    id: 'xIDgrYolg8pSsPgrif3x',
    description: 'Feature line for included or optional return transfer service on an offer or booking',
  },
  privateTransport: {
    defaultMessage: 'Private Transport',
    id: 'j_QT9Vo94tJjiFeW5caN',
    description: 'Label for private vehicle transport option in inclusions, tours, and transfers',
  },
  hotelTransfer: {
    defaultMessage: 'Hotel Transfer',
    id: '4zcINLoZJbs6aXEbbWCq',
    description: 'Label for transfer service between hotel and airport or point-to-point in itinerary',
  },
  flightDetails: {
    defaultMessage: 'Flight details',
    id: 'wkQ6ZxhHUkd_e7nRF3YT',
    description: 'Section or link heading to view detailed flight schedule and segment information',
  },
  flightNumber: {
    defaultMessage: 'Flight number',
    id: 'EOqOr68c1Ex0t-KQE-PG',
    description: 'Form or summary field label for the airline flight number in booking and PNR context',
  },
  searchFlights: {
    defaultMessage: 'Search flights',
    id: 'xJFt7wa_gx9pbtdb5F6J',
    description: 'Call-to-action to open the flight search flow from offer page or merchandising',
  },
  selectFlights: {
    defaultMessage: 'Select flights',
    id: '4BpwHoJJFR3CS0iVD5zv',
    description: 'Call-to-action to choose specific flights in a bundle or add-on path before checkout',
  },
  noFlightsAvailable: {
    defaultMessage: 'No flights available',
    id: '8OOg65fPf5tRtvXy9t07',
    description: 'Empty or error state when no flight options match the current search or route',
  },
  makeFlightFullyRefundable: {
    defaultMessage: 'Make your flight fully refundable',
    id: 'VKsNF3BDk6ZRctC-CI0c',
    description: 'Upsell line for optional refundable fare upgrade on flight add-on in checkout',
  },
  fullyRefundableFlights: {
    defaultMessage: 'Fully refundable flights',
    id: 'WfapLERCmEO8dw7u7yXV',
    description: 'Merchandising badge or filter when flight inventory is sold as fully refundable',
  },
  directMaldivesFlights: {
    defaultMessage: 'Direct Maldives Flights',
    id: 'Zafi41TE3h7k8mobnIU5',
    description: 'Navigation and campaign label for direct Maldives flight routes in regional nav and promos',
  },
  leMaldivesCharter: {
    defaultMessage: 'Luxury Escapes Exclusive Service',
    id: 'q7z2RQGjvN1bfL20IE1g',
    description: 'Branded label for the Maldives charter flight product in flight bundle campaign content',
  },
})

export default flightBundleGlossaryMessages
